module.exports = __webpack_public_path__ + "static/media/CTLI_6-315w.8040fec3.png";